import { render, staticRenderFns } from "./BalanceRecordsView.vue?vue&type=template&id=438c46c1&"
import script from "./BalanceRecordsView.vue?vue&type=script&lang=js&"
export * from "./BalanceRecordsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports